module.exports = __webpack_public_path__ + "img/gyb-themed-logo.452bf37f.svg";